import createIsPristine from './selectors/isPristine';
import plain from './structure/plain';

export default createIsPristine(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/isPristine.js
// module id = 1016
// module chunks = 0